import { selectIn } from 'common/util/selector'

const dashboardBase = (state, props) => state.main.settings.dashboard
const widgetBase = (state, props) => state.main.settings.widgets

export const dashboard = selectIn(dashboardBase, 'details')
export const dashboardLoading = selectIn(dashboardBase, 'details_loading')
export const widgetLibrary = selectIn(widgetBase, 'list')
export const widgetLibraryLoading = selectIn(widgetBase, 'list_loading')
